module.exports = __webpack_public_path__ + "img/homescreen-capacitor.b33d64d1.png";